import { MatTableColumn } from '@/shared/components/mat-table-base/mat-table.types';
import {
  SubscriptionOverdraftTableHeaders,
  SubscriptionOverdraftTableRow,
} from './subscription-overdraft.list.types';

export function getSubscriptionOverdraftColumns(
  headers: SubscriptionOverdraftTableHeaders
): MatTableColumn<SubscriptionOverdraftTableRow>[] {
  return [
    {
      id: 'metric',
      label: headers.metric,
      dataPath: 'metric',
      minWidth: '140px',
      width: '38%',
      sortable: false,
      resizable: false,
    },
    {
      id: 'current_usage',
      label: headers.currentUsage,
      dataPath: 'current_usage',
      minWidth: '100px',
      width: '22%',
      sortable: false,
      resizable: false,
      cellsAlign: 'right',
      headerAlign: 'right',
    },
    {
      id: 'plan_limit',
      label: headers.planLimit,
      dataPath: 'plan_limit',
      minWidth: '100px',
      width: '22%',
      sortable: false,
      resizable: false,
      cellsAlign: 'right',
      headerAlign: 'right',
    },
    {
      id: 'overdraft_cost',
      label: headers.overdraftCost,
      dataPath: 'overdraft_cost',
      minWidth: '100px',
      width: '18%',
      sortable: false,
      resizable: false,
      cellsAlign: 'right',
      headerAlign: 'right',
    },
  ];
}
